import { NumberTypeMap, TRUE_AND_FALSE } from '../base/define';
import { GoodsInfoBrief } from '../goods/define';
import { LIVE_STATUS } from '../live/define';
import { ANSWER_CORRECT_TYPE, QuestionType } from '../question/define';
import { SORT_TYPE } from '../shared/define/Sort';
import {
  Unit,
  UnitRecord,
  UnitContentType,
  SUBJECT_TYPE,
  Video,
  CORRECT_STATUS,
  MathLevel,
  PROJECT_THEME_TYPE,
} from '../unitResource/define';

export const UNLOCK_PERCENT = 90;

// 后台在用
export enum PLATFORM_TYPE {
  STEAM = 1,
  KADA = 2,
}

// 前台在用
export enum PLATFORM_TYPE_NEW {
  KADA = 0,
  STEAM = 1,
}

export enum ACCOUNT_TYPE {
  PHONE = 0,
  MAIL,
  UID,
  KADA_ID,
}

export enum COURSE_STATUS {
  MODIFIED = 1,
  RELEASED,
}

export enum ALBUM_STATUS {
  RELEASED,
  MODIFIED,
  DELETED,
  CREATED,
}

export enum ALBUM_PUBLISH_STATUS {
  DRAFT,
  ONLINE,
  OFFLINE,
}

export enum CHAPTER_STATUS {
  EMPTY = 1,
  MODIFIED,
  RELEASED,
  DELETED, // 前端临时状态
  MOVED, // 前端临时状态
}

export enum STUDENT_TYPE {
  OFFICIAL = 1,
  AUDIT,
  TEACHER,
  SUSPEND_CLASSES,
}

export enum CONTACT_STATUS {
  UNCONTACTED = 0,
  CONTACTED = 1,
}

export enum INTENT_TYPE {
  S = 'S',
  A = 'A',
  B = 'B',
  C = 'C',
  END = 'END', // 停课
  DELAY = 'DELAY', // 延期
  CHANGE_NUMBER = 'CHANGE_NUMBER', // 换号
  REFUND = 'REFUND', // 退费
}

export enum ACCESS_ROLE_TYPE {
  FREE = 0,
  VIP = 1,
}

export const ACCESS_ROLE_TYPE_MAP: NumberTypeMap = {
  [ACCESS_ROLE_TYPE.FREE]: '免费',
  [ACCESS_ROLE_TYPE.VIP]: '会员',
};

export enum RENEWAL_STATUS {
  UNRENEWAL = 0,
  RENEWAL = 1,
}

export enum STUDENT_SEARCH_TYPE {
  PHONE = 1,
  UID = 2,
  NAME = 3,
}

// 是否配置打卡：0：未配置；1：有配置。
export enum COURSE_SIGN_STATUS {
  UN_SIGN,
  SIGN,
}

// 课时是否可学
export enum COURSE_UNIT_LEARNABLE_STATUS {
  UNABLE,
  ABLE,
}

// 作业学习状态：1.未做 2.未完成 3.完成但是有错题 4.完成且全对
export enum HOMEWORK_LEARN_STATUS {
  NOT_START = 1,
  NOT_COMPLETE,
  COMPLETE_WITH_ERRORS,
  COMPLETE_AND_RIGHT
}

// 发布类型：1：随时可看；2：具体时间；3：学完本章前面课时。4.批量解锁
export enum RELEASE_TYPE {
  ANY_TIME = 1,
  SPECIFIC_TIME,
  AFTER_FINISH_PREVIOUS,
  BATCH_RELEASE,
}
// 是否允许用户允许自定义设置解锁 0：不允许；1：允许。
export enum USER_CUSTOM_FLAG {
  NOT_ALLOWED,
  ALLOWED,
}

export interface CourseReleaseConfig {
  releaseWeek: number;
  releaseTime: string;
  releaseChapterNum: number;
}

export interface CourseInfo extends CourseBaseInfo {
  type: number;
  isDeleted: number;
  gmtCreate: number;
  gmtModified: number;
  studentAmount: number;
  bindGoodsAmount: number;
  hasRelation?: boolean;
  publishStatus?: COURSE_STATUS;
  releaseType?: number;
  releaseWeek?: number;
  releaseTime?: string;
  initChapterNum?: number;
  releaseChapterNum: number;
  releasePeriodList?: CourseReleaseConfig[];
  userCustomFlag?: USER_CUSTOM_FLAG;
  userCustomMaxNum?: number;
  tips: string;
  operableFlag?: TRUE_AND_FALSE;
}

export interface CourseBaseInfo {
  id?: number;
  name: string;
  webThumbnail: string;
  appThumbnail: string;
  chapterBackground?: string;
  remark: string;
  color?: string;
  subjectType: SUBJECT_TYPE;
  subType: number;
  courseSeriesId?: number;
}

export enum ALBUM_TYPE {
  AUDIO = 1,
  VIDEO,
}

export interface AlbumBaseInfo {
  id?: number;
  name: string;
  description: string;
  remark?: string;
  thumbnail: string;
  type: ALBUM_TYPE;
}

export interface AlbumLink {
  albumId: number;
  title: string;
  url: string;
  thumbnail?: string;
}

export enum ALBUM_FINISH_STATUS {
  UNFINISHED,
  FINISHED,
}
export interface AlbumInfo extends AlbumBaseInfo {
  isDeleted: number;
  status: ALBUM_STATUS;
  gmtCreate?: number;
  gmtModified?: number;
  unitList?: Unit[];
  resourcesCount: number;
  weight: number;
  freeStartTime: number;
  freeEndTime: number;
  publishStatus: ALBUM_PUBLISH_STATUS;
  averageFinishedRate: number;
  totalPlayCount: number;
  albumLink?: AlbumLink;
  finishStatus?: ALBUM_FINISH_STATUS;
  projectWallSwitch: TRUE_AND_FALSE;
  projectWallId?: number | null;
}

export enum COURSE_PAY_TYPE {
  FREE = 0,
  PAY,
}
export interface ChapterInfo {
  id?: number;
  preChapterId?: number | null;
  courseId?: number;
  chapterName: string;
  releaseType: RELEASE_TYPE;
  releaseTime?: number;
  chapterImgUrl?: string;
  chapterNo?: string;
  seq?: number;
  contentStatus: CHAPTER_STATUS;
  gmtCreate?: number;
  gmtModified?: number;
  unitList?: Unit[];
  isFold?: boolean;
  needPay: COURSE_PAY_TYPE;
}

export interface ChapterRequest {
  chapterId: number;
  preChapterId?: number | null;
}

export interface ChapterUnitListRequest {
  chapterId: number;
  templateUnitIds?: Array<number>;
  projectThemeId?: number;
  steamMathBean?: MathLevel;
}

export interface UnitRequest {
  unitId: number;
  preUnitId?: number | null;
  isTemplateUnit?: boolean;
}

export interface TeacherInfo {
  id: number;
  nickName: string;
  wechatAccount: string;
  wechatQrCode: string;
  headImgUrl: string;
}

export interface CourseDetailInfo {
  course: {
    id: number;
    name: string;
  };
  hasExpired: boolean;
  teacher?: TeacherInfo;
}

export interface CourseUnitInfo {
  id?: number;
  chapterId: number;
  name: string;
  contentType: UnitContentType;
  contentId: number;
  releaseType: RELEASE_TYPE;
  releaseTime: number;
  percent: number;
  hasFinish: boolean;
  progress: number;
  roomId?: number;
  liveReleaseTime?: number;
  liveStatus?: LIVE_STATUS;
  liveWatchTime?: number;
  videoForReplay?: Unit;
  learnable?: COURSE_UNIT_LEARNABLE_STATUS;
  homeworkWrongTimes?: number;
  homeworkLearnStatus?: HOMEWORK_LEARN_STATUS;
  reviewFlag?: REVIEW_FLAG;
}

export interface CourseChapterInfo {
  id?: number;
  chapterName: string;
  chapterNo: string;
  releaseType: RELEASE_TYPE;
  releaseTime: number;
  isLock: boolean;
  unlockTime: number;
  percent: number;
  unitList: CourseUnitInfo[];
  hasSign: boolean;
  canSign: COURSE_SIGN_STATUS;
}

export interface StudentInfo {
  id?: number;
  isDeleted: number;
  gmtCreate: number;
  gmtModified: number;
  uid: number;
  studentType: number;
  hasContact?: number;
  intentType?: string;
  isSecondBuy?: number;
  notSecondBuyReason?: number;
  courseId: number;
  consultantId?: number;
  tutorId?: number;
  consultantName?: string;
  tutorName?: string;
  studentName: string;
  mobile: string;
  remark: string;
  orderCount: number;
  groupCode: number;
  totalVideoLesson: number;
  hasLearnedVideoCount: number;
  traceName?: string;
  totalHomework: number;
  finishedHomework: number;
  coursePeriodId?: number;
  week?: number;
  specificTime?: string;
  loginAccount?: string;
  hasAddWechat?: number; // 是否添加微信 0:未添加 1:已添加
  suspendClassFlag?: number;
  suspendClassTime?: number;
}

export interface StudentRecordInfo {
  courseId: number;
  uid: number;
  unitLearnRecordList: UnitRecord[];
}

export interface StudentProjectInfo {
  courseId: number;
  uid: number;
  chapterName: string;
  chapterNum: string;
  correctsStatus?: CORRECT_STATUS;
}

export interface StudentRequest {
  courseId: number;
  uid: number;
}

export interface StudentSuspendRequest {
  courseId: number;
  uid: number;
  suspendClassFlag: number; // 0 - 停课， 1 - 复课
}

export enum COURSE_VALID_TYPE {
  FOREVER = -1,
  SOME = 1,
}
export interface StudentEnrollRequest {
  studentType: number;
  courseId: number;
  consultantId: number | null;
  tutorId: number | null;
  coursePeriodId: number | null;
  accountType: number;
  accountValue: string;
  courseValidDay: number;
}

export interface StudentMultiEnrollRequest {
  courseId: number;
  phoneList: Array<number>;
  courseValidDay: number;
}

export interface StudentRollOverRequest {
  uid?: number;
  oldCourseId: number;
  newCourseId: number | null;
  reason?: string;
  isKeep?: boolean;
}

export interface StudentSearchTerms {
  pageIndex: number;
  pageSize: number;
  courseId: number;
  searchType?: number | null;
  keyword?: string;
  studentType?: number | null;
  hasContact?: number | null;
  intentType?: number | null;
  isSecondBuy?: number | null;
  consultantId?: number | null;
  tutorId?: number | null;
  groupCode: number | null;
  roomId?: number | null;
  liveId?: number | null;
  learnVideoSortType?: SORT_TYPE | null;
  learnLiveSortType?: SORT_TYPE | null;
  homeworkSortType?: SORT_TYPE | null;
  userProjectSortType?: SORT_TYPE | null;
  coursePeriodId?: number | null;
}

export interface ConsultantInfo {
  id?: number;
  isDeleted: number;
  gmtCreate: number;
  gmtModified: number;
  courseId: number;
  consultantId: number;
  canServiceCount: number;
  remarkName: string;
  realName: string;
  mobile: string;
  hasServiceCount: number;
  hasSelected: boolean;
  headImgUrl: string;
  weights?: number;
  operableFlag: TRUE_AND_FALSE;
  steamGoodsBeanList?: GoodsInfoBrief[];
}

export interface ConsultantOption {
  consultantId: number;
  remarkName: string;
}

export interface ConsultantOverview {
  hasSelectConsultantCount: number;
  canServiceStudentCount: number;
}

export interface ConsultantRequest {
  id?: number;
  consultantId: number;
  courseId: number;
  studentUid?: number;
  canServiceCount?: number;
  hasSelected?: boolean;
  weights?: number;
  goodsIdList?: number[];
}

export interface TutorInfo {
  id?: number;
  isDeleted: number;
  gmtCreate: number;
  gmtModified: number;
  courseId: number;
  tutorId: number;
  remarkName: string;
  realName: string;
  mobile: string;
  hasServiceCount: number;
  isSelected: boolean;
  hasSelected: boolean;
  headImgUrl: string;
  operableFlag: TRUE_AND_FALSE;
}

export interface TutorOption {
  id?: number;
  tutorId: number;
  name: string;
}

export interface TutorOverview {
  hasSelectTutorCount: number;
}

export interface TutorRequest {
  id?: number;
  tutorId: number;
  courseId: number;
  isSelected?: boolean;
}

export interface CourseSearchTerms {
  pageIndex: number;
  pageSize: number;
  platformType: number;
  courseType?: number;
  keyword?: string;
  subjectType?: number;
  subType?: number;
}

export interface UserReportInfo {
  statistic: UserReportStatistic;
  studyDetail: UserReportDetail[];
}

export interface UserReportStatistic {
  studyTime: number;
  studyCourseCount: number;
  studyKnowledgeCount: number;
  comment: string;
}

export interface UserReportDetail {
  courseName: string;
  chapters: UserReportChapter[];
}

export interface UserReportChapter {
  knowledgeList: UserReportKnowledge[];
  units: Unit[];
}

export interface UserReportKnowledge {
  seq: number;
  value: string;
}

export interface UserReportBanner {
  imgUrl: string;
  clickUrl: string;
}

export interface CourseReportInfo {
  id?: number;
  canSign: COURSE_SIGN_STATUS;
  courseId: number;
  signContent?: string;
  headerImg: string;
  footerImg: string;
  color: string;
  lastChapterSeq?: number;
}

export interface CourseChapterInfoInReport {
  id: number;
  courseId: number;
  chapterName: string;
  chapterNo: string;
  chapterImgUrl?: string;
  subjectType?: number;
  subType?: number;
}

export interface CourseHomeworkAccuracyInfo {
  homeworkAccuracy: string;
  name: string;
  correctNumber: number;
  errorNumber: number;
}

export interface QuestionItem {
  name: string;
  questionType: QuestionType;
  resourceUrl: string;
  score: number;
  mappedContent?: string;
}
export interface CourseReportInfoForUser {
  reportConfig: CourseReportInfo;
  chapterInfo: CourseChapterInfoInReport;
  extInfo: {
    uid: number;
    realName?: string;
    phone: string;
    hasSign: boolean;
    headImgUrl: string;
    courseName: string;
    startLearnTime: number;
    studyTime?: number;
    answerTimes?: number;
    liveLearnTime?: number;
    liveAnswerTimes?: number;
    homeworkStatistic?: CourseHomeworkAccuracyInfo[];
    knowledgeList?: string[];
    lastChapterSeq?: number;
    questionList?: QuestionItem[];
  };
}

export interface CourseRequest {
  courseId?: number;
  keyword?: string;
  withDetail?: TRUE_AND_FALSE;
}

export interface CourseChapterRequest {
  chapterId: number;
}

export interface CourseReportRequest {
  chapterId: number;
  uid?: number | null;
}

export interface GeekInviteIdRequest {
  id: number;
}

export interface DeleteCourseRequest {
  id: number;
}

export interface CourseRemarkRequest {
  courseId?: number;
  uid: number;
}

export interface Remark {
  remark: RemarkDetail;
  remarkLog?: RemarkLog[];
  changeCourseLog?: ChangeCourseLog;
}

export interface RemarkDetail {
  id?: number | null;
  name?: string;
  birthday?: number;
  age?: number;
  address?: string;
  remark?: string;
  device?: string;
}

export interface RemarkLog {
  operatorName: string;
  operatorId: number;
  operatorTime: number;
}

export interface ChangeCourseLog {
  operatorName: string;
  originCourse: string;
  currentCourse: string;
  reason: string;
}

export interface CourseUnit {
  video: {
    shdVideoUrl: string;
    duration: number;
  };
  anchor: {
    id: number;
    content: string;
    type: number;
    duration: number;
    startTime: number;
  }[];
  unit: {
    name: string;
    progress: number;
    percent: number;
  };
}
export interface HomeworkStatistic {
  chapterId: number;
  chapterName: string;
  chapterNum: string;
  homeworkId: number;
  templateHomeworkId: number;
  templateRemarkName: string;
  firstCorrectRate: string;
  lastCorrectRate: string;
  userCount: string;
  finishedCount: number;
}

export interface ProjectStatistic {
  unitId: number;
  chapterId: number;
  chapterName: string;
  chapterNum: string;
  projectThemeId: number;
  projectThemeName: string;
  projectThemeType: PROJECT_THEME_TYPE;
  formalStudentCount: number;
  finishedProjectCount: number;
  correctsProjectCount: number;
  unCorrectsCount: number;
  myCorrectsCount: number;
}

export enum VIEW_FLAG {
  NOT_VIEW = 0,
  VIEWED,
}

export enum REVIEW_FLAG {
  TO_REVIEW = 0,
  REVIEWED,
}

export interface HomeworkSingleStatistic {
  uid: number;
  realName: string;
  studentType: STUDENT_TYPE;
  phone: string;
  tutorName: string;
  groupName: string;
  consultantName: string;
  firstCorrectRate: string;
  lastCorrectRate: string;
  firstStartTime: number;
  firstEndTime: number;
  lastStartTime: number;
  lastEndTime: number;
  viewFlag: VIEW_FLAG;
  remark?: string;
  reviewFlag?: REVIEW_FLAG;
  reviewTime?: number;
}

export enum HOMEWORK_WORK_TYPE {
  NOT_COMPLETE = 1,
  COMPLETE,
  ONLY_WRONG,
  RETRY,
}
export interface HomeworkUserRecord {
  num: number;
  recordId: number;
  correctRate: string;
  recordType: HOMEWORK_WORK_TYPE;
  questionList: ({
    seq: number;
    questionId: number;
    answerFlag: ANSWER_CORRECT_TYPE;
  })[];
  startAnswerTime: number;
  endAnswerTime: number;
}

export interface StudentHomeworkInfo {
  uid: number;
  courseId: number;
  chapterNum: string;
  chapterName: string;
  homeworkId: number;
  correctRate: string;
}

export interface HomeworkInfo {
  chapterId: number;
  chapterNum: string;
  chapterName: string;
  homeworkName: string;
  homeworkId: string;
  subjectType: SUBJECT_TYPE;
}

export interface RemarkRequest {
  uid: number;
  homeworkId: number;
  remark: string;
}

export interface HomeworkReviewInfo {
  content: string;
  reviewTutorName?: string;
  reviewTutorId?: number;
  reviewTime?: number;
}

export interface CourseAboutConfig {
  url: string;
  price: number;
  nickName: string;
  wechatAccount: string;
  wechatQrCode: string;
  headImgUrl: string;
}
export interface AlbumUpdateRequest {
  albumId: number;
  finishStatus: ALBUM_FINISH_STATUS;
}

export interface CourseLearningGuideContent {
  title: string;
  url: string;
}
export interface CourseLearningGuideInfo {
  id?: number;
  courseId?: number;
  groupButtonDisplay: number;
  officialUrl?: string;
  groupQrUrl: string;
  content: string;
  contentJson?: CourseLearningGuideContent[];
  display: number;
}

export interface GuideCourseResponse {
  id?: number;
  name: string;
  afterChapterNo: number;
  videoId: number | null;
  introduceUrl?: string;
  buyButtonDisplay: number;
  courseId?: number;
  autoShow: number;
  steamVideoBean?: Video;
  cardImageUrl: string;
}
export enum AUTO_SHOW {
  CLOSE,
  OPEN,
}
export const AUTO_SHOW_MAP = {
  [AUTO_SHOW.CLOSE]: '关闭',
  [AUTO_SHOW.OPEN]: '开启',
};

export enum BUY_BUTTON_DISPLAY {
  CLOSE,
  OPEN,
}
export const BUY_BUTTON_DISPLAY_MAP = {
  [AUTO_SHOW.CLOSE]: '关闭',
  [AUTO_SHOW.OPEN]: '开启',
};

export enum DISPLAY {
  CLOSE,
  OPEN,
}
export const DISPLAY_MAP = {
  [AUTO_SHOW.CLOSE]: '关闭',
  [AUTO_SHOW.OPEN]: '开启',
};
export interface SteamCourseGoodsBean {
  id?: number;
  display: number;
  buttonName: string;
  buttonTag: string;
  videoId: number | null;
  snapshotSec: number;
  coursePosterUrl: string;
  courseName: string;
  courseDesc: string;
  introduction: string;
  introductionUrl: string;
  buyButtonDisplay: number;
  buyButtonName: string;
  buyButtonTag: string;
  buyUrl: string;
  vipButtonDisplay: number;
  vipButtonName: string;
  vipButtonTag: string;
  courseId?: number;
  isDeleted: number;
  gmtCreate: number;
  gmtModified: number;
  steamVideoBean: Video | null;
}

export interface CourseEvaluateInfo {
  id: number;
  nickName: string;
  content: string;
  evaluateTime: number;
  headImgUrl: string;
  courseId: number;
}

export interface UserLearnChapterRequest {
  platformType: PLATFORM_TYPE_NEW;
  chapterId?: number;
  termId?: number;
  unitId?: number;
  contentType?: UnitContentType;
}
export interface ReleaseProcess {
  id?: number;
  userName?: string;
  phoneNumer?: string;
  uid?: number;
  effectiveState?: number | null;
  totalValidDays?: number;
  remainDays?: number;
  releaseType: number;
  initChapterNum: number;
  courseId?: number;
  firstEnrollTime?: number;
  releasePeriodList?: CourseReleaseConfig[];
  userCustomFlag?: USER_CUSTOM_FLAG;
  userCustomMaxNum?: number;
  tips?: string;
}

export interface RemainDays {
  uid: number;
  courseId: number;
  remainDays: number;
  remark: string;
}

export interface UserValidRecord {
  recordDesc: string;
  operateTime: number;
  operatorName: string;
  sourceType: string;
  sourceValue: string;
  remark: string;
}

export enum COURSE_RELEASE_TYPE {
  ONLINE, // 上线即解锁
  CYCLE, // 周期性解锁
}
export const COURSE_RELEASE_TYPE_MAP: NumberTypeMap = {
  [COURSE_RELEASE_TYPE.ONLINE]: '上线即解锁',
  [COURSE_RELEASE_TYPE.CYCLE]: '周期性解锁',
};

export enum RELEASE_WEEK {
  MONDAY = 1, // 星期一
  TUESDAY, // 星期二
  WEDNESDAY, // 星期三
  THURSDAY, // 星期四
  FRIDAY, // 星期五
  SATURDAY, // 星期六
  SUNDAY, // 星期日
}
export const RELEASE_WEEK_MAP: NumberTypeMap = {
  [RELEASE_WEEK.MONDAY]: '每周一',
  [RELEASE_WEEK.TUESDAY]: '每周二',
  [RELEASE_WEEK.WEDNESDAY]: '每周三',
  [RELEASE_WEEK.THURSDAY]: '每周四',
  [RELEASE_WEEK.FRIDAY]: '每周五',
  [RELEASE_WEEK.SATURDAY]: '每周六',
  [RELEASE_WEEK.SUNDAY]: '每周日',
};

export enum RELEASE_PROCESS_TYPE {
  PHONE = 1, // 手机号
  NAME, // 姓名
  UID, // 用户ID
}

export const RELEASE_PROCESS_TYPE_MAP = {
  [RELEASE_PROCESS_TYPE.PHONE]: '手机号',
  [RELEASE_PROCESS_TYPE.NAME]: '姓名',
  [RELEASE_PROCESS_TYPE.UID]: '用户ID',
};

export enum RELEASE_PROCESS_EFFECTIVE_STATE {
  UN_EFFECT, // 已失效
  EFFECT, // 生效中
}
export const RELEASE_PROCESS_EFFECTIVE_STATE_MAP = {
  [RELEASE_PROCESS_EFFECTIVE_STATE.UN_EFFECT]: '已失效',
  [RELEASE_PROCESS_EFFECTIVE_STATE.EFFECT]: '生效中',
};

export interface ReleaseProcessRequest {
  type: RELEASE_PROCESS_TYPE;
  keyword: string;
  effectiveState: RELEASE_PROCESS_EFFECTIVE_STATE | null;
  sort?: SORT_TYPE | null;
}

export enum CONTENT_DISPLAY {
  PERMANENT = -1, // todo 这个属性值设置的有点奇怪
  HIDE = 0,
  SHOW
}

export interface CourseLearnGuide {
  id: number;
  courseId: number;
  groupButtonDisplay: CONTENT_DISPLAY;
  groupQrUrl: string;
  officialUrl: string;
  content: string;
  display: CONTENT_DISPLAY;
  courseExpireTime: number;
  buyCourseUrl?: string;
  courseGoodsSwitch?: DISPLAY;
  learnRemindFlag?: DISPLAY;
  remainDays?: number;
  userCustomFlag?: USER_CUSTOM_FLAG;
  releaseType?: COURSE_RELEASE_TYPE;
  releasePeriodList?: CourseReleaseConfig[];
}

export interface GetCourseGoodsForWebRequest {
  courseId: number;
  _trace_name?: string;
}
export enum CLICK_RESPONSE_TYPE {
  RETURN_COURSE = 1,
  NO_RESPONSE,
  LINK_URL
}
export const CLICK_RESPONSE_TYPE_MAP = {
  [CLICK_RESPONSE_TYPE.RETURN_COURSE]: '返回该课程',
  [CLICK_RESPONSE_TYPE.NO_RESPONSE]: '无反应',
  [CLICK_RESPONSE_TYPE.LINK_URL]: '跳转链接',
};
export interface CourseSystemCard {
  imgUrl: string;// 图片链接
  clickResponseType: CLICK_RESPONSE_TYPE;
  jumpLink: string;// 跳转链接
  iosLink?: string; // 分端 ios跳转链接
  distinguishLink?: boolean;
  weight: number;// 排序权重
}
export interface CourseSystemInfo {
  weight: number;// 排序权重
  courseSystemSwitch: DISPLAY;// 课程体系开关 0:关闭 1:开启
  courseSystemTitle: string;// 课程体系标题
  courseSystemCards: CourseSystemCard[];// 课程体系阶段
  courseId?: number;// 课程ID
}

export interface CourseGoodsConfig {
  buyCourseUrl: string;
  courseGoodsSwitch: DISPLAY;
  defaultBthName: string | null;
  defaultLabel: string | null;
  newUserBthName: string | null;
  newUserLabel: string | null;
  newUserTimeLimitBthName: string | null;
  newUserTimeLimitBthLabel: string | null;
}
export interface CourseTrialConfig {
  title: string;
  content: string;
  buySingleBthSwitch: DISPLAY;
  buySingleBthText: string | null;
  buySingleBthLabel: string | null;
  buySingleBthDesc: string | null;
  buySingleJumpLink: string;
  buyVipBthSwitch: DISPLAY;
  buyVipDefaultBthText: string | null;
  buyVipDefaultBthLabel: string | null;
  buyVipDefaultBthDesc: string | null;
  buyVipNewUserBthText: string | null;
  buyVipNewUserBthLabel: string | null;
  buyVipNewUserBthDesc: string | null;
  buyVipNewUserTimeLimitBthText: string | null;
  buyVipNewUserTimeLimitBthLabel: string | null;
  buyVipNewUserTimeLimitBthDesc: string | null;
}
export interface CourseExtend {
  id?: number;
  courseGoodsConfigObj: CourseGoodsConfig;
  courseTrialConfigObj: CourseTrialConfig;
}

export enum UPDATE_FLAG{
UN_CHANGE,
CHANGED
}
export interface UserReleaseInfo {
  courseId?: number;
  courseName?: string;
  releaseType?: COURSE_RELEASE_TYPE;
  learnRemindFlag?: DISPLAY;
  userCustomMaxNum?: number;
  updateFlag?: UPDATE_FLAG;
  tips?: string;
  userCustomFlag?: USER_CUSTOM_FLAG;
  releasePeriodList?: CourseReleaseConfig[];
}

export enum TARGET_TYPE {
  COURSE = 1,
  ALBUM,
}

export interface ProjectWallInfo {
  id?: number;
  targetId: number;
  targetType: TARGET_TYPE;
  projectWallSwitch: TRUE_AND_FALSE;
  bgImgUrl?: string;
  courseSeriesId: number | null;
  showName?: string;
}

export interface UpdateLearnRemindRequest {
  courseId: number;
  learnRemindFlag: DISPLAY;
}

export interface GetProjectWallInfoRequest {
  projectWallId?: number;
  targetId?: number;
  targetType?: TARGET_TYPE;
}

export interface GetCoursePeriodRequest {
  needStudentFlag: TRUE_AND_FALSE;
  courseId: number;
}

export interface CoursePeriod {
  id?: number;
  courseId: number;
  week: RELEASE_WEEK | null;
  specificTime: string;
  studentNum: number;
}

export interface UpdateCoursePeriodListRequest {
  courseId: number;
  coursePeriodList: CoursePeriod[];
}

export interface UpdateCoursePeriodInfoRequest {
  courseId: number;
  coursePeriodId: number;
}

export interface CoursePeriodInfo {
  courseId: number;
  courseName: string;
  periodList: CoursePeriod[];
  selectPeriodId: number;
  isEnrollCourse: boolean;
}
export interface ChapterFinishPopup {
  id?: number;
  chapterNum?: number;
  popupUrl: string;
  voiceUrl?: string;
  iosUrl?: string;
  jumpUrl: string;
  courseId: number;
  distinguishLink?: boolean;
  yreadPopupUrl?: string;
  yreadJumpUrl?: string;
}

export enum UPGRADE_STATUS {
  SYNCING = 0,
  FINISH,
}

export interface CourseLearnData {
  id?: number;
  name?: string;
  courseId?: number;
  folderId: number | null;
  icon: string;
  unlockFlag?: TRUE_AND_FALSE;
  appEntryFlag?: TRUE_AND_FALSE;
}

export enum ROLLOVER_STATUS {
  DOING = 0,
  DONE,
}

export interface ChapterTailPromote {
  courseId: number;
  imageUrl: string;
  appLink: string;
  iosLink?: string;
}

export interface ChapterReleaseInfo {
  chapterId: number;
  releaseTime: number;
  releaseType: number;
}
